const PLUGIN_NAME = 'kp-form';

export { PLUGIN_NAME };
